
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesSettings = Marionette.ItemView.extend({
		template: null,
		form_template: null,
		ui: {
			'form':              '',
			'update_submit':     '',
			'remove_submit':     '',
			'combination_error': ''
		},
		events: {
			'change @ui.form':         'formChanged',
			'submit @ui.form':         'getFormData',
			'click @ui.update_submit': 'getFormData',
			'click @ui.remove_submit': 'deleteLeague'
		},
		onRender: function() {
			if (this.form) {
				this.ui.form.append(this.form.$el);
				this.bindUIElements();
				this.formChanged();
			}
		},
		initialize: function() {
			this.scrollToTop();
			this.league_id = this.getOption('league_id');
			this.league    = this.getOption('league');
			this.rounds    = this.getOption('rounds');
			this.user      = this.getOption('user');

			this.listenTo(this.league, 'leagues:errors', this.showErrors);
			this.listenTo(this.league, 'leagues:update:success', this.leagueUpdated);
			this.listenTo(this.league, 'leagues:delete:success', this.leagueDeleted);
			
			var complete = [
				this.league.show().fetch({ data: { id: this.league_id } }),
				this.rounds.fetch({ cache: true, expires: 60 })
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},
		initTemplate: function() {
			if (this.initData().isCanAccess()) {
				this.trigger('leagues:view:menu', this.league);
				return this.setForm().setModelData().render();
			}

			return this;
		},
		initData: function() {
			this.league.setCommissioner(this.user.get('id'));
			this.rounds.invoke('set', {"selected": false});
			this.round_id = this.rounds.getActualRoundId();
			this.is_started = this.league.get('status') != 'scheduled';
			this.rounds.get(this.round_id).set({'selected': true});
			this.buy_round_ids = this.rounds.getByeRoundIds();
			this.originalStartRound = this.league.get('start_round');
			return this;
		},
		isCanAccess: function() {
			if (!this.league.get('id')) {
				this.trigger('leagues:http_status:404');

				return false;
			}
			else if (!this.league.get('is_commissioner')) {
				this.trigger('leagues:http_status:403');

				return false;
			}

			return true;
		},
		setForm1: function() {
			this.form = new Backbone.Form({ template: this.form_template, model: this.league });
			this.form.render().fields.start_round.editor.setOptions(this.rounds.getRoundsOptions());
			return this;
		},

		setForm: function() {

			this.form = new Backbone.Form({template: this.form_template, model : this.league});

			this.form.render();

			if (this.league.get('status') == 'scheduled') {
				this.form.fields.start_round.editor.setOptions(this.rounds.getRoundsOptions());
			}
			else {
				var start_round = this.league.get('start_round');

				this.form.fields.start_round.editor.setOptions([{
					val:   start_round,
					label: 'Round ' + start_round
				}]);
				this.form.fields.privacy.editor.$el.closest('.field-set').toggleClass('disabled', true).find('input').prop('disabled', true);
			}

			this.formChanged();

			//this.listenTo(this.form, 'coaches_box:change', function(form, editor){

			//if(Boolean(parseInt(editor.getValue()))){
			//	this.league.coaches_box_switch_on();
			//}
			//else {
			//	this.league.coaches_box_switch_off();
			//}

			//});

			return this;
		},
		setModelData: function() {
			this.model.set({
				league: this.league.toJSON(),
				rounds: this.rounds.toJSON()
			});

			return this;
		},
		getFormData: function() {
			if (!this.ui.update_submit.hasClass('disabled')) {
				var data = this.form.getValue();

				if (data.start_round < this.round_id ) {
					delete data.start_round;
				}
				this.showPreloader();
				this.league.update(data);
			}

			return this;
		},
		formChanged: function() {
			var data   = this.form.getValue(),
				fields = this.form.fields;
						
			this.league.set(data);
			this.ui.update_submit.text('Update comp').removeClass('disabled');

			return this;
		},
		deleteLeague: function() {
			if (confirm('Are you sure? All teams will be removed from this comp.')) {
				this.showPreloader();
				this.league.delete();
			}

			return this;
		},
		leagueUpdated: function() {
			this.hidePreloader();
			this.ui.update_submit.text('Comp updated').addClass('disabled');

			return this;
		},
		leagueDeleted: function() {
			this.hidePreloader();
			this.trigger('leagues_settings:deleted');

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));
